import {Component, ElementRef, Inject, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";

export const MY_FORMATS = {
    parse: {
        dateInput: ['YYYY-MM-DD']
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {DateAdapter} from "angular-calendar";
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {catchError, debounceTime, first, map, startWith, switchMap} from "rxjs/operators";
import {CustomerDialogComponent} from "../../customer/dialog/customerDialog.component";
import {User} from "../../models";
import {CustomerContactDetailsDialogComponent} from "../../customer/dialog/customerContactDetailsDialog.component";
import {Service} from "../../models/service";
import {DeleteEventDialogComponent} from "./deleteEventDialog.component";
import {ReservationDataService} from "../../services/reservationData.service";
import {ServiceResourceGroup} from "../../models/serviceResourceGroup";
import {GroupActivity} from "../../models/groupActivity";
import {Router} from "@angular/router";
import {Observable, of} from "rxjs";
import {Items} from "../../models/items";
import {UserService} from "../../services";
import {GroupActivityService} from "../service/groupActivity.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ParticipantsListDialogComponent} from "./participantsListDialog.component";
import {ConfirmExerciseDialogComponent} from "./confirmExerciseDialog.component";

@Component({
    selector: 'event-details-form-dialog',
    templateUrl: './eventDetailsDialog.component.html',
    styleUrls: ['./eventDetailsDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ]
})

export class EventDetailsDialogComponent {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    deleteDialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;
    locale: string;
    services: Service[];
    service: Service;
    endHour: string;
    startHour: string;
    groups: any[];
    form: FormGroup;
    filteredOptions: Observable<User[]>;
    customers: User[];
    adding: boolean = false;

    hours = [
        '08:00', '08:10', '08:20', '08:30', '08:40', '08:50',
        '09:00', '09:10', '09:20', '09:30', '09:40', '09:50',
        '10:00', '10:10', '10:20', '10:30', '10:40', '10:50',
        '11:00', '11:10', '11:20', '11:30', '11:40', '11:50',
        '12:00', '12:10', '12:20', '12:30', '12:40', '12:50',
        '13:00', '13:10', '13:20', '13:30', '13:40', '13:50',
        '14:00', '14:10', '14:20', '14:30', '14:40', '14:50',
        '15:00', '15:10', '15:20', '15:30', '15:40', '15:50',
        '16:00', '16:10', '16:20', '16:30', '16:40', '16:50',
        '17:00', '17:10', '17:20', '17:30', '17:40', '17:50',
        '18:00', '18:10', '18:20', '18:30', '18:40', '18:50',
        '19:00', '19:10', '19:20', '19:30', '19:40', '19:50',
        '20:00', '20:10', '20:20', '20:30', '20:40', '20:50',
        '21:00', '21:10', '21:20', '21:30', '21:40', '21:50',
        '22:00',
    ];

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param _formBuilder
     * @param translationLoader
     * @param translate
     */
    constructor(
        public matDialogRef: MatDialogRef<EventDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private reservationDataService: ReservationDataService,
        private formBuilder: FormBuilder,
        private _router: Router,
        private userService: UserService,
        private groupActivityService: GroupActivityService,
        private _matSnackBar: MatSnackBar,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults

        this.action = _data.action;
        this.event = _data.event;
        this.locale = _data.locale;
        this.services = _data.services;
        this.service = _data.service;

        this.eventForm = this.createEventForm();

        // if (this.event.service) {
        //     for (let j = 0; j < this.event.service.resourceGroups.length; j++) {
        //         console.log('aaaa');
        //         this.addReservedResources();
        //     }
        // }

        this.form = this.formBuilder.group({
            customer: [],
        });
    }

    ngOnInit() {
        this.userService.getAllCustomers().subscribe((res: Items)=>{
            this.customers = res.items;
            this.filteredOptions = this.form.get('customer').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        if (value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });
    }

    lookup(value: string): Observable<Items> {
        return this.userService.getAllCustomersBy(value).pipe(
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }

    getResourceGroups(serviceId: string): ServiceResourceGroup[] {
        if (serviceId !== null) {
            for (let i = 0; i < this.services.length; i++) {
                if (this.services[i].id !== serviceId) {
                    continue;
                }

                for (let j = 0; j < this.services[i].resourceGroups.length; j++) {
                    let id = '';

                    if (this.event.reservedResources.length>0) {
                        console.log(this.event.reservedResources);
                        id = this.event.reservedResources[j].id;
                    }

                    this.addReservedResources(id);
                }

                this.groups = this.services[i].resourceGroups;
                return this.services[i].resourceGroups;
            }
        }

        return [];
    }

    goToGroupActivityDetails(event: ReservationData) {
        this._router.navigate(['/calendar/group-activity/' + event.id]).then(() => {

        });
    }

    get f() { return this.form.controls; }

    reservedResources(): FormArray {
        return this.eventForm.get('reservedResources') as FormArray;
    }

    newReservedResource(id: any): FormGroup {
        return this.formBuilder.group({
            id: [id]
        });
    }

    addReservedResources(id: any) {
        this.reservedResources().push(this.newReservedResource(id));
    }

    removeHour(hourIdx: number) {
        this.reservedResources().removeAt(hourIdx);
    }

    showCustomerContactDetails(customer: User) {
        this.dialogRef = this._matDialog.open(CustomerContactDetailsDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                customer: customer,
                services: this.services,
            },
            width: '550px',
        });
    }

    showConfirmEventDeleteDialog(event: ReservationData) {
        this.deleteDialogRef = this._matDialog.open(DeleteEventDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.reservationDataService.delete(event.id).pipe(first())
                    .subscribe(response => {
                        this.deleteDialogRef.close();
                        this.matDialogRef.close();
                    }, error => {
                        this.deleteDialogRef.close();
                    });
            }, (err) => {
                console.log(err);
            });
    }

    createEventForm(): FormGroup {
        return this._formBuilder.group({
            description: [this.event.description],
            date: [this.event.startDate.substring(0, 10)],
            startHour: [this.formatHour(this.event.startDate)],
            endHour: [this.formatHour(this.event.endDate)],
            service: [this.event.service?this.event.service.id:''],
            reservedResources: this.formBuilder.array([]),
        });
    }

    onDateChange(date: any) {
        date = (new Date(date.value));
        date.setTime(date.getTime()+(5*60*60*1000));

        let formattedDate = date.toISOString().split('T')[0];
        this.eventForm.controls['date'].setValue(formattedDate);
    }

    formatHour(date: any): string {
        return date.substring(11, 16);
    }

    displayFn(userId: User): string {
        let userName = '';

        if (userId && userId.firstName && userId.firstName.length>0) {
            userName = userName + userId.firstName;
        }

        if (userId && userId.lastName && userId.lastName.length>0) {
            userName = userName + " " + userId.lastName;
        }

        if (userId && userId.phone && userId.phone.length>0) {
            userName = userName + " " + userId.phone;
        }

        return (userId)? userName: '';
    }

    addCustomerToTraining(form: FormGroup) {
        this.groupActivityService.addParticipant(this.event, form.getRawValue().customer).pipe(first())
            .subscribe((res: GroupActivity) => {
                this.reservationDataService.getById(this.event.id).pipe(first())
                    .subscribe((reservation: ReservationData) => {
                        this.event = reservation;
                    });
                this.adding = false;
                this._matSnackBar.open('Participant has been added', 'OK', {
                    verticalPosition: 'top',
                    duration: 5000,
                    panelClass: ['snackbar-success']
                });
                this.form.get('customer').setValue('');
            }, err => {
                this.adding = false;
                this._matSnackBar.open('Error - ' + err, 'OK', {
                    verticalPosition: 'top',
                    duration: 5000,
                    panelClass: ['snackbar-error']
                });
            });
    }

    displayParticipantsList(event: ReservationData) {
        this.dialogRef = this._matDialog.open(ParticipantsListDialogComponent, {
            panelClass: 'participants-list-dialog',
            data      : {
                action : 'show',
                event: event,
                locale: this.locale,
            },
            width: '700px',
        });
    }

    confirmExercise(user: User, service: Service): void {
        this.dialogRef = this._matDialog.open(ConfirmExerciseDialogComponent, {
            panelClass: 'confirm-exercise-dialog',
            data      : {
                user: user,
                service: service,
                reservationDataId: this.event.id
            },
            width: '400px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.dialogRef.close();
            }, (err) => {
                console.log(err);
            });
    }
}
